import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bdbbda5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-row tw-flex-1 tw-items-center tw-h-[60px]" }
const _hoisted_2 = { class: "tw-relative" }
const _hoisted_3 = { class: "tw-flex tw-flex-end tw-items-center tw-bg-[#FFFFFF] tw-flex-1" }

import { ref, watch } from "vue";
import AssessmentAnswerType1 from "../assessments/assessmentAnswerType1.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import { wizardQuestionAnswerType } from "@/utils/constants";
import BaseDropDown from "../common/form/baseDropDown.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'questionPage',
  props: {
  title: {
    type: String,
    default: "",
  },
  customTitleStyle: {
    type: String,
    required: false,
    default: "tw-text-[14px]",
  },
  questionType: {
    type: String,
    default: wizardQuestionAnswerType.radio,
  },
  dropdownData: {
    type: Array,
    default: () => [],
  },
  customClass: {
    type: String,
    required: false,
    default: "p-25",
  },
  placeholder: {
    type: String,
    default: "",
  },
  customSelectContainer: {
    type: String,
    required: false,
    default: "",
  },
  isRequired: {
    type: Boolean,
    default: true,
  },
  isTrue: {
    type: [Number, String],
    default: 0,
  },
},
  emits: ["check:answer", "update:answer"],
  setup(__props, { emit: emits }) {

const props = __props;




const answerQuestion = ref(props.isTrue);

const handleAnswer = (answer: any) => {
  answerQuestion.value = answer;
  emits("check:answer", answer);
  emits("update:answer", answer);
};
watch(
  () => props.isTrue,
  (newValue, oldValue) => {
    if (newValue) {
      answerQuestion.value = newValue;
    }
  },
  { deep: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'tw-w-full tw-flex tw-leading-[100%] tw-justify-between tw-gap-[20px] tw-bg-[#ffffff] default-box',
      __props.customClass,
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("span", {
          class: _normalizeClass([
            'tw-font-poppins tw-text-[#231F20] tw-leading-[140%] tw-font-medium tw-mr-[3px]',
            __props.customTitleStyle,
          ])
        }, _toDisplayString(__props.title), 3)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (__props.questionType === _unref(wizardQuestionAnswerType).radio)
        ? (_openBlock(), _createBlock(AssessmentAnswerType1, {
            key: 0,
            value: answerQuestion.value,
            "is-wizard-page": true,
            "is-true": __props.isTrue,
            "onUpdate:value": handleAnswer
          }, null, 8, ["value", "is-true"]))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(__props.placeholder) + " ", 1),
      (__props.questionType === _unref(wizardQuestionAnswerType).select)
        ? (_openBlock(), _createBlock(BaseDropDown, {
            key: 1,
            id: 'wizard-services-dropdown',
            modelValue: answerQuestion.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((answerQuestion).value = $event)),
              handleAnswer
            ],
            placeholder: __props.placeholder,
            "custom-select-container": __props.customSelectContainer,
            data: __props.dropdownData as IDropDownData[],
            validation: {},
            "class-name": 'gray-dropdown-container tw-h-[56px]'
          }, null, 8, ["modelValue", "placeholder", "custom-select-container", "data"]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})